import React, { useState } from "react";
import PaymentLink from "./containers/PaymentLink";
import InvoiceLink from "./containers/InvoiceLink";
import { Routes, Route, BrowserRouter } from "react-router-dom";

const App = () => {

  return (
    <div>
      
      <BrowserRouter>
        <Routes>
          <Route exact path="/payment-request/:id" element={<PaymentLink />} />
          <Route exact path="/invoice-payment-request/:id" element={<InvoiceLink />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
